<div class="flex items-center justify-center w-full md:p-4">
    Sua resposta foi recebida. Obrigado :)
</div>
